"use strict";

var _AcademicCapIcon = require("./components/AcademicCapIcon");

var _AcademicCapIcon2 = _interopRequireDefault(_AcademicCapIcon);

var _AlignCenterIcon = require("./components/AlignCenterIcon");

var _AlignCenterIcon2 = _interopRequireDefault(_AlignCenterIcon);

var _AlignImageCenterIcon = require("./components/AlignImageCenterIcon");

var _AlignImageCenterIcon2 = _interopRequireDefault(_AlignImageCenterIcon);

var _AlignImageLeftIcon = require("./components/AlignImageLeftIcon");

var _AlignImageLeftIcon2 = _interopRequireDefault(_AlignImageLeftIcon);

var _AlignImageRightIcon = require("./components/AlignImageRightIcon");

var _AlignImageRightIcon2 = _interopRequireDefault(_AlignImageRightIcon);

var _AlignLeftIcon = require("./components/AlignLeftIcon");

var _AlignLeftIcon2 = _interopRequireDefault(_AlignLeftIcon);

var _AlignRightIcon = require("./components/AlignRightIcon");

var _AlignRightIcon2 = _interopRequireDefault(_AlignRightIcon);

var _AlphabeticalSortIcon = require("./components/AlphabeticalSortIcon");

var _AlphabeticalSortIcon2 = _interopRequireDefault(_AlphabeticalSortIcon);

var _ArchiveIcon = require("./components/ArchiveIcon");

var _ArchiveIcon2 = _interopRequireDefault(_ArchiveIcon);

var _BackIcon = require("./components/BackIcon");

var _BackIcon2 = _interopRequireDefault(_BackIcon);

var _BeakerIcon = require("./components/BeakerIcon");

var _BeakerIcon2 = _interopRequireDefault(_BeakerIcon);

var _BillingIcon = require("./components/BillingIcon");

var _BillingIcon2 = _interopRequireDefault(_BillingIcon);

var _BlockQuoteIcon = require("./components/BlockQuoteIcon");

var _BlockQuoteIcon2 = _interopRequireDefault(_BlockQuoteIcon);

var _BoldIcon = require("./components/BoldIcon");

var _BoldIcon2 = _interopRequireDefault(_BoldIcon);

var _BuildingBlocksIcon = require("./components/BuildingBlocksIcon");

var _BuildingBlocksIcon2 = _interopRequireDefault(_BuildingBlocksIcon);

var _BulletedListIcon = require("./components/BulletedListIcon");

var _BulletedListIcon2 = _interopRequireDefault(_BulletedListIcon);

var _CheckboxIcon = require("./components/CheckboxIcon");

var _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon);

var _CheckmarkIcon = require("./components/CheckmarkIcon");

var _CheckmarkIcon2 = _interopRequireDefault(_CheckmarkIcon);

var _CloseIcon = require("./components/CloseIcon");

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _CloudIcon = require("./components/CloudIcon");

var _CloudIcon2 = _interopRequireDefault(_CloudIcon);

var _CodeIcon = require("./components/CodeIcon");

var _CodeIcon2 = _interopRequireDefault(_CodeIcon);

var _CoinsIcon = require("./components/CoinsIcon");

var _CoinsIcon2 = _interopRequireDefault(_CoinsIcon);

var _CollapsedIcon = require("./components/CollapsedIcon");

var _CollapsedIcon2 = _interopRequireDefault(_CollapsedIcon);

var _CollectionIcon = require("./components/CollectionIcon");

var _CollectionIcon2 = _interopRequireDefault(_CollectionIcon);

var _CommentIcon = require("./components/CommentIcon");

var _CommentIcon2 = _interopRequireDefault(_CommentIcon);

var _DocumentIcon = require("./components/DocumentIcon");

var _DocumentIcon2 = _interopRequireDefault(_DocumentIcon);

var _EditIcon = require("./components/EditIcon");

var _EditIcon2 = _interopRequireDefault(_EditIcon);

var _EmailIcon = require("./components/EmailIcon");

var _EmailIcon2 = _interopRequireDefault(_EmailIcon);

var _ExpandedIcon = require("./components/ExpandedIcon");

var _ExpandedIcon2 = _interopRequireDefault(_ExpandedIcon);

var _EyeIcon = require("./components/EyeIcon");

var _EyeIcon2 = _interopRequireDefault(_EyeIcon);

var _GlobeIcon = require("./components/GlobeIcon");

var _GlobeIcon2 = _interopRequireDefault(_GlobeIcon);

var _GoToIcon = require("./components/GoToIcon");

var _GoToIcon2 = _interopRequireDefault(_GoToIcon);

var _GroupIcon = require("./components/GroupIcon");

var _GroupIcon2 = _interopRequireDefault(_GroupIcon);

var _HashtagIcon = require("./components/HashtagIcon");

var _HashtagIcon2 = _interopRequireDefault(_HashtagIcon);

var _Heading1Icon = require("./components/Heading1Icon");

var _Heading1Icon2 = _interopRequireDefault(_Heading1Icon);

var _Heading2Icon = require("./components/Heading2Icon");

var _Heading2Icon2 = _interopRequireDefault(_Heading2Icon);

var _Heading3Icon = require("./components/Heading3Icon");

var _Heading3Icon2 = _interopRequireDefault(_Heading3Icon);

var _HighlightIcon = require("./components/HighlightIcon");

var _HighlightIcon2 = _interopRequireDefault(_HighlightIcon);

var _HomeIcon = require("./components/HomeIcon");

var _HomeIcon2 = _interopRequireDefault(_HomeIcon);

var _HorizontalRuleIcon = require("./components/HorizontalRuleIcon");

var _HorizontalRuleIcon2 = _interopRequireDefault(_HorizontalRuleIcon);

var _Icon = require("./components/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _ImageIcon = require("./components/ImageIcon");

var _ImageIcon2 = _interopRequireDefault(_ImageIcon);

var _InfoIcon = require("./components/InfoIcon");

var _InfoIcon2 = _interopRequireDefault(_InfoIcon);

var _InputIcon = require("./components/InputIcon");

var _InputIcon2 = _interopRequireDefault(_InputIcon);

var _InsertAboveIcon = require("./components/InsertAboveIcon");

var _InsertAboveIcon2 = _interopRequireDefault(_InsertAboveIcon);

var _InsertBelowIcon = require("./components/InsertBelowIcon");

var _InsertBelowIcon2 = _interopRequireDefault(_InsertBelowIcon);

var _InsertLeftIcon = require("./components/InsertLeftIcon");

var _InsertLeftIcon2 = _interopRequireDefault(_InsertLeftIcon);

var _InsertRightIcon = require("./components/InsertRightIcon");

var _InsertRightIcon2 = _interopRequireDefault(_InsertRightIcon);

var _ItalicIcon = require("./components/ItalicIcon");

var _ItalicIcon2 = _interopRequireDefault(_ItalicIcon);

var _JournalIcon = require("./components/JournalIcon");

var _JournalIcon2 = _interopRequireDefault(_JournalIcon);

var _KeyboardIcon = require("./components/KeyboardIcon");

var _KeyboardIcon2 = _interopRequireDefault(_KeyboardIcon);

var _LeafIcon = require("./components/LeafIcon");

var _LeafIcon2 = _interopRequireDefault(_LeafIcon);

var _LightBulbIcon = require("./components/LightBulbIcon");

var _LightBulbIcon2 = _interopRequireDefault(_LightBulbIcon);

var _LinkIcon = require("./components/LinkIcon");

var _LinkIcon2 = _interopRequireDefault(_LinkIcon);

var _ManualSortIcon = require("./components/ManualSortIcon");

var _ManualSortIcon2 = _interopRequireDefault(_ManualSortIcon);

var _MenuIcon = require("./components/MenuIcon");

var _MenuIcon2 = _interopRequireDefault(_MenuIcon);

var _MoonIcon = require("./components/MoonIcon");

var _MoonIcon2 = _interopRequireDefault(_MoonIcon);

var _MoreIcon = require("./components/MoreIcon");

var _MoreIcon2 = _interopRequireDefault(_MoreIcon);

var _NewDocumentIcon = require("./components/NewDocumentIcon");

var _NewDocumentIcon2 = _interopRequireDefault(_NewDocumentIcon);

var _NextIcon = require("./components/NextIcon");

var _NextIcon2 = _interopRequireDefault(_NextIcon);

var _NotepadIcon = require("./components/NotepadIcon");

var _NotepadIcon2 = _interopRequireDefault(_NotepadIcon);

var _OpenIcon = require("./components/OpenIcon");

var _OpenIcon2 = _interopRequireDefault(_OpenIcon);

var _OrderedListIcon = require("./components/OrderedListIcon");

var _OrderedListIcon2 = _interopRequireDefault(_OrderedListIcon);

var _PadlockIcon = require("./components/PadlockIcon");

var _PadlockIcon2 = _interopRequireDefault(_PadlockIcon);

var _PaletteIcon = require("./components/PaletteIcon");

var _PaletteIcon2 = _interopRequireDefault(_PaletteIcon);

var _PinIcon = require("./components/PinIcon");

var _PinIcon2 = _interopRequireDefault(_PinIcon);

var _PlusIcon = require("./components/PlusIcon");

var _PlusIcon2 = _interopRequireDefault(_PlusIcon);

var _PrivateCollectionIcon = require("./components/PrivateCollectionIcon");

var _PrivateCollectionIcon2 = _interopRequireDefault(_PrivateCollectionIcon);

var _ProfileIcon = require("./components/ProfileIcon");

var _ProfileIcon2 = _interopRequireDefault(_ProfileIcon);

var _QuestionMarkIcon = require("./components/QuestionMarkIcon");

var _QuestionMarkIcon2 = _interopRequireDefault(_QuestionMarkIcon);

var _SearchIcon = require("./components/SearchIcon");

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _SettingsIcon = require("./components/SettingsIcon");

var _SettingsIcon2 = _interopRequireDefault(_SettingsIcon);

var _ShapesIcon = require("./components/ShapesIcon");

var _ShapesIcon2 = _interopRequireDefault(_ShapesIcon);

var _StarredIcon = require("./components/StarredIcon");

var _StarredIcon2 = _interopRequireDefault(_StarredIcon);

var _StrikethroughIcon = require("./components/StrikethroughIcon");

var _StrikethroughIcon2 = _interopRequireDefault(_StrikethroughIcon);

var _SunIcon = require("./components/SunIcon");

var _SunIcon2 = _interopRequireDefault(_SunIcon);

var _TableIcon = require("./components/TableIcon");

var _TableIcon2 = _interopRequireDefault(_TableIcon);

var _TableOfContentsIcon = require("./components/TableOfContentsIcon");

var _TableOfContentsIcon2 = _interopRequireDefault(_TableOfContentsIcon);

var _TeamIcon = require("./components/TeamIcon");

var _TeamIcon2 = _interopRequireDefault(_TeamIcon);

var _TodoListIcon = require("./components/TodoListIcon");

var _TodoListIcon2 = _interopRequireDefault(_TodoListIcon);

var _TrashIcon = require("./components/TrashIcon");

var _TrashIcon2 = _interopRequireDefault(_TrashIcon);

var _UserIcon = require("./components/UserIcon");

var _UserIcon2 = _interopRequireDefault(_UserIcon);

var _VehicleIcon = require("./components/VehicleIcon");

var _VehicleIcon2 = _interopRequireDefault(_VehicleIcon);

var _WarningIcon = require("./components/WarningIcon");

var _WarningIcon2 = _interopRequireDefault(_WarningIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  AcademicCapIcon: _AcademicCapIcon2.default,
  AlignCenterIcon: _AlignCenterIcon2.default,
  AlignImageCenterIcon: _AlignImageCenterIcon2.default,
  AlignImageLeftIcon: _AlignImageLeftIcon2.default,
  AlignImageRightIcon: _AlignImageRightIcon2.default,
  AlignLeftIcon: _AlignLeftIcon2.default,
  AlignRightIcon: _AlignRightIcon2.default,
  AlphabeticalSortIcon: _AlphabeticalSortIcon2.default,
  ArchiveIcon: _ArchiveIcon2.default,
  BackIcon: _BackIcon2.default,
  BeakerIcon: _BeakerIcon2.default,
  BillingIcon: _BillingIcon2.default,
  BlockQuoteIcon: _BlockQuoteIcon2.default,
  BoldIcon: _BoldIcon2.default,
  BuildingBlocksIcon: _BuildingBlocksIcon2.default,
  BulletedListIcon: _BulletedListIcon2.default,
  CheckboxIcon: _CheckboxIcon2.default,
  CheckmarkIcon: _CheckmarkIcon2.default,
  CloseIcon: _CloseIcon2.default,
  CloudIcon: _CloudIcon2.default,
  CodeIcon: _CodeIcon2.default,
  CoinsIcon: _CoinsIcon2.default,
  CollapsedIcon: _CollapsedIcon2.default,
  CollectionIcon: _CollectionIcon2.default,
  CommentIcon: _CommentIcon2.default,
  DocumentIcon: _DocumentIcon2.default,
  EditIcon: _EditIcon2.default,
  EmailIcon: _EmailIcon2.default,
  ExpandedIcon: _ExpandedIcon2.default,
  EyeIcon: _EyeIcon2.default,
  GlobeIcon: _GlobeIcon2.default,
  GoToIcon: _GoToIcon2.default,
  GroupIcon: _GroupIcon2.default,
  HashtagIcon: _HashtagIcon2.default,
  Heading1Icon: _Heading1Icon2.default,
  Heading2Icon: _Heading2Icon2.default,
  Heading3Icon: _Heading3Icon2.default,
  HighlightIcon: _HighlightIcon2.default,
  HomeIcon: _HomeIcon2.default,
  HorizontalRuleIcon: _HorizontalRuleIcon2.default,
  Icon: _Icon2.default,
  ImageIcon: _ImageIcon2.default,
  InfoIcon: _InfoIcon2.default,
  InputIcon: _InputIcon2.default,
  InsertAboveIcon: _InsertAboveIcon2.default,
  InsertBelowIcon: _InsertBelowIcon2.default,
  InsertLeftIcon: _InsertLeftIcon2.default,
  InsertRightIcon: _InsertRightIcon2.default,
  ItalicIcon: _ItalicIcon2.default,
  JournalIcon: _JournalIcon2.default,
  KeyboardIcon: _KeyboardIcon2.default,
  LeafIcon: _LeafIcon2.default,
  LightBulbIcon: _LightBulbIcon2.default,
  LinkIcon: _LinkIcon2.default,
  ManualSortIcon: _ManualSortIcon2.default,
  MenuIcon: _MenuIcon2.default,
  MoonIcon: _MoonIcon2.default,
  MoreIcon: _MoreIcon2.default,
  NewDocumentIcon: _NewDocumentIcon2.default,
  NextIcon: _NextIcon2.default,
  NotepadIcon: _NotepadIcon2.default,
  OpenIcon: _OpenIcon2.default,
  OrderedListIcon: _OrderedListIcon2.default,
  PadlockIcon: _PadlockIcon2.default,
  PaletteIcon: _PaletteIcon2.default,
  PinIcon: _PinIcon2.default,
  PlusIcon: _PlusIcon2.default,
  PrivateCollectionIcon: _PrivateCollectionIcon2.default,
  ProfileIcon: _ProfileIcon2.default,
  QuestionMarkIcon: _QuestionMarkIcon2.default,
  SearchIcon: _SearchIcon2.default,
  SettingsIcon: _SettingsIcon2.default,
  ShapesIcon: _ShapesIcon2.default,
  StarredIcon: _StarredIcon2.default,
  StrikethroughIcon: _StrikethroughIcon2.default,
  SunIcon: _SunIcon2.default,
  TableIcon: _TableIcon2.default,
  TableOfContentsIcon: _TableOfContentsIcon2.default,
  TeamIcon: _TeamIcon2.default,
  TodoListIcon: _TodoListIcon2.default,
  TrashIcon: _TrashIcon2.default,
  UserIcon: _UserIcon2.default,
  VehicleIcon: _VehicleIcon2.default,
  WarningIcon: _WarningIcon2.default
};